import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChatbotBuilder } from '../components/chatbot/FlowEditor';

export default function ChatbotBuilderPage() {
  const { instanceId, flowId } = useParams();
  const navigate = useNavigate();

  if (!instanceId || !flowId) {
    return null;
  }

  return (
    <ChatbotBuilder
      instanceId={instanceId}
      flowId={flowId}
      onBack={() => navigate(`/chatbot/${instanceId}`)}
    />
  );
}